export enum MarginStatuses {
    Drafting = 1
}
